import React from 'react';

import { Table } from 'antd';
import { PAGE_SIZE_OPTIONS, SCROLL_Y } from 'constants/table';
import { columns } from './datasource';

function PRPTable({
  items,
  loading,
  totalRows,
  current,
  pageSize,
  onRowClick,
  onChange,
}) {
  return (
    <Table
      columns={columns}
      dataSource={items}
      loading={loading}
      pagination={{
        current,
        pageSize,
        total: totalRows,
        showSizeChanger: true,
        pageSizeOptions: PAGE_SIZE_OPTIONS,
      }}
      scroll={{ x: 1600, y: SCROLL_Y }}
      rowKey="id"
      onRow={(record) => {
        return {
          onDoubleClick: () => onRowClick(record),
        };
      }}
      onChange={onChange}
    />
  );
}

export { PRPTable };
